import axios from "axios";
import { EsiServerStatus } from "../interfaces/esiTypes";
import { ConstellationInfo, SystemInfo } from "../interfaces/eveTypes";

const baseURL = "https://esi.evetech.net/latest/";

// CCP removed the old meta status.json (per-route green/yellow/red) endpoint.
// /status/ only reports overall tranquility server status now.
export const getEsiStatus = async (): Promise<EsiServerStatus | null> => {
  try {
    const { data } = await axios.get<EsiServerStatus>(
      baseURL + "status/?datasource=tranquility"
    );

    return data;
  } catch (err) {
    return null;
  }
};

export const getSecureRouteJumps = async (
  originID: number,
  destinationId: number
): Promise<number> => {
  // Jita to Lumegen seems like it's 27 Jumps in this, however it looks 18 in game?
  // Jita 30000142
  // Lumegen 30003432

  try {
    const result = await axios.get(
      baseURL +
        `route/${originID}/${destinationId}/?datasource=tranquility&flag=secure`
    );
    return result.data.length - 1;
  } catch (err) {
    if (err.response.data.error === "No route found")
      return err.response.data.error;
  }
};
export type SystemIDMap = {
  id: number;
  name: string;
};

export const getSystemsIds = async (
  systemNames: string[]
): Promise<SystemIDMap[]> => {
  const result = await axios.post(
    baseURL + `universe/ids/?datasource=tranquility&language=en`,
    systemNames
  );
  return result.data["systems"];
};

export const getSystemInfo = async (systemId: number): Promise<SystemInfo> => {
  // https://esi.evetech.net/latest/universe/systems/30000003
  const result = await axios.get(baseURL + `universe/systems/${systemId}`);
  return result["data"];
};

export const getConstellationInfo = async (
  constellationID: number
): Promise<ConstellationInfo> => {
  // /universe/constellations/{constellation_id}/
  const result = await axios.get(
    baseURL + `universe/constellations/${constellationID}`
  );
  return result["data"];
};

// Canary check against the actual endpoints this app depends on, since ESI
// no longer publishes a per-route status feed to read this from.
export const checkEndpointStatus = async (): Promise<boolean> => {
  const jita = 30000142;
  const amarr = 30002187;

  try {
    const systemInfo = await getSystemInfo(jita);
    await Promise.all([
      getConstellationInfo(systemInfo.constellation_id),
      getSystemsIds(["Jita"]),
      getSecureRouteJumps(jita, amarr),
    ]);
    return true;
  } catch (err) {
    return false;
  }
};

export const getWormholeClass = (constellation: ConstellationInfo) => {
  const hashMap: { [letter: string]: string } = {
    A: "C1",
    B: "C2",
    C: "C3",
    D: "C4",
    E: "C5",
    F: "C6",
    G: "Thera",
    H: "Shattered",
    K: "Drifter",
  };

  const name = constellation.name;
  const grade = hashMap[name[0]];
  const cls = `${grade}`;

  return cls;
};
